/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu Dec 05 2024
 **/

import { Configure } from "@/frameworks/libraries";

import { useChat } from "../../API";
import { useChatRoomActions } from "../../chat";

export default function useOpenCreateChat() {
	const chatAPI = useChat();
	const chatRoomActions = useChatRoomActions();

	const checkChatExists = async (userID: string) => {
		const { data } = await chatAPI.dm.checkExist.execute({
			userIds: [...new Set([userID, Configure.userID])]
		});
		return data;
	};

	const openCreateChat = async (userID: string) => {
		const data = await checkChatExists(userID);
		if (data?.exists) {
			chatRoomActions.common.open({ channelID: data.roomId || "", type: "DM" });
		} else {
			await chatRoomActions.dm.create({ userIDs: [userID] });
		}
	};

	return {
		openCreateChat
	};
}
